import shave from 'shave';

export default () => {
    shave('.truncate-3', 66);
    shave('.truncate-2', 45);
}